import React from 'react';
import './index.scss';

const Spinner = ({ variant }) => <span className={`loader ${variant ? variant : ''}`}></span>;

export default Spinner;
